export default __webpack_public_path__ + "static/media/3_drop_off_your_items.4e39cf59.png";